import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  ThemeProvider as Mui4ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import {
  ThemeProvider as Mui5ThemeProvider,
  createTheme,
} from "@mui/material/styles";
import LanguageContext from "./LanguageContext";

const ThemeModeContext = createContext({
  mode: "dark",
  toggleMode: () => {},
});

export const ThemeModeProvider = ({ children }) => {
  const { direction } = useContext(
    LanguageContext
  );

  const [mode, setMode] = useState(() => {
    return localStorage.getItem("ossThemeMode") === "light"
      ? "light"
      : "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem("ossThemeMode", mode);
  }, [mode]);

  const colors = useMemo(
    () =>
      mode === "light"
        ? {
            background: "#f4f7fb",
            paper: "#ffffff",
            primaryText: "#1f2937",
            secondaryText: "#526170",
          }
        : {
            background: "rgb(50, 65, 80)",
            paper: "rgb(30, 46, 58)",
            primaryText: "#ffffff",
            secondaryText: "#d5dde5",
          },
    [mode]
  );

  const mui5Theme = useMemo(
    () =>
      createTheme({
        direction,
        palette: {
          mode,
          primary: { main: "#2e79ca" },
          background: {
            default: colors.background,
            paper: colors.paper,
          },
          text: {
            primary: colors.primaryText,
            secondary: colors.secondaryText,
          },
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: "none",
              },
            },
          },
        },
      }),
    [mode, colors, direction]
  );

  const mui4Theme = useMemo(
    () =>
      createMuiTheme({
        direction,
        palette: {
          type: mode,
          primary: { main: "#2e79ca" },
          background: {
            default: colors.background,
            paper: colors.paper,
          },
          text: {
            primary: colors.primaryText,
            secondary: colors.secondaryText,
          },
        },
      }),
    [mode, colors, direction]
  );

  const toggleMode = () => {
    setMode((currentMode) =>
      currentMode === "dark" ? "light" : "dark"
    );
  };

  return (
    <ThemeModeContext.Provider value={{ mode, toggleMode }}>
      <Mui4ThemeProvider theme={mui4Theme}>
        <Mui5ThemeProvider theme={mui5Theme}>
          {children}
        </Mui5ThemeProvider>
      </Mui4ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

export default ThemeModeContext;
